var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHardware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#001838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#64B3E1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3333 21.3333V19.6667C46.3333 18.75 45.5833 18 44.6667 18H41.3333C40.4167 18 39.6667 18.75 39.6667 19.6667V21.3333C38.75 21.3333 38 22.0833 38 23V28C38 28.9167 38.75 29.6667 39.6667 29.6667H41.3333V41.1833C41.3333 42.9167 40.0667 44.4833 38.35 44.65C36.35 44.85 34.6667 43.2833 34.6667 41.3333V24.9C34.6667 21.35 31.9833 18.25 28.4333 18.0167C27.5231 17.9557 26.6101 18.0825 25.7509 18.3892C24.8917 18.6959 24.1048 19.1759 23.439 19.7996C22.7731 20.4232 22.2426 21.1771 21.8804 22.0143C21.5182 22.8516 21.332 23.7544 21.3333 24.6667V36.3333H19.6667C18.75 36.3333 18 37.0833 18 38V43C18 43.9167 18.75 44.6667 19.6667 44.6667V46.3333C19.6667 47.25 20.4167 48 21.3333 48H24.6667C25.5833 48 26.3333 47.25 26.3333 46.3333V44.6667C27.25 44.6667 28 43.9167 28 43V38C28 37.0833 27.25 36.3333 26.3333 36.3333H24.6667V24.8167C24.6667 23.0833 25.9333 21.5167 27.65 21.35C29.65 21.15 31.3333 22.7167 31.3333 24.6667V41.1C31.3333 44.65 34.0167 47.75 37.5667 47.9833C41.45 48.2333 44.6667 45.1667 44.6667 41.3333V29.6667H46.3333C47.25 29.6667 48 28.9167 48 28V23C48 22.0833 47.25 21.3333 46.3333 21.3333Z",
    fill: "#ECF6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHardware);
export default __webpack_public_path__ + "static/media/home-hardware.070005a948c3a324d26f938cfe2ed346.svg";
export { ForwardRef as ReactComponent };